// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__18buR","requiredAsterisk":"Info_requiredAsterisk__1z-pu"};